(function(config) {
    'use strict';

    angular.module('file.services', [
            'ngResource'
        ])
        .factory('fileDataSrvc', fileDataSrvc)
        .factory('fileSrvc', fileSrvc)
        .factory('summernoteImageDataSrvc', summernoteImageDataSrvc)
        .factory('summernoteImageSrvc', summernoteImageSrvc);

    fileDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function fileDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/files/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            productMaterialsFiles : {
                method: 'GET',
                url: config.api + '/api/v1/files/admin_product_materials_files/',
            }
        });
    }

    fileSrvc.$inject = ['fileDataSrvc', 'modalSrvc'];

    function fileSrvc(fileDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    fileDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    summernoteImageDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function summernoteImageDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/summernote-files/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    summernoteImageSrvc.$inject = ['summernoteImageDataSrvc'];

    function summernoteImageSrvc(summernoteImageDataSrvc) {

        return {
            uploadImage: uploadImage,
            deleteImage: deleteImage
        };

        function uploadImage(image) {
            return summernoteImageDataSrvc.create({
                file: image
            });
        }

        function deleteImage(id) {
            return summernoteImageDataSrvc.delete({
                pk: id
            });
        }
    }
})(window.config);
